import { render, staticRenderFns } from "./VesselMonitoringSingleBayHold.vue?vue&type=template&id=f6c33fa4&scoped=true"
import script from "./VesselMonitoringSingleBayHold.vue?vue&type=script&lang=ts"
export * from "./VesselMonitoringSingleBayHold.vue?vue&type=script&lang=ts"
import style0 from "./VesselMonitoringSingleBayHold.vue?vue&type=style&index=0&id=f6c33fa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c33fa4",
  null
  
)

export default component.exports